<div class="edit_icon">
    <i class="material-icons pointer" title="{{ 'CONSTANTS.EDIT' | translate }}">edit</i>
</div>